<div class="relative w-full h-full bg-slate-50 flex flex-col overflow-hidden font-prompt">

  <!-- Header Bar -->
  <div
    class="relative bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pt-5 pb-6 rounded-b-[2.5rem] shadow-lg z-10 shrink-0 text-white border-b border-white/5">

    <div class="absolute left-4 top-4 z-20">
      <button
        class="w-9 h-9 bg-white/10 hover:bg-white/20 backdrop-blur-md shadow-sm rounded-full flex justify-center items-center active:scale-95 transition-all border border-white/10 text-white outline-none"
        (click)="goback()">
        <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
      </button>
    </div>

    <div class="flex flex-col items-center justify-center mt-1 text-center">
      <h2 class="text-base font-black tracking-wide text-white">
        {{ currentLang === "TH" ? "รายการค้างชำระทั้งหมด" : "Pending Payments" }}
      </h2>
      <p class="text-[9px] text-amber-400 font-bold mt-1 uppercase tracking-wider">
        {{ currentLang === "TH" ? "ชำระค่าลงทะเบียนหรือต่ออายุบัตรจอดรถ" : "Pay registration or card renewal fees" }}
      </p>
    </div>
  </div>

  <!-- Main Scroll Container -->
  <div class="flex-1 overflow-y-auto custom-scrollbar px-4 pb-20 pt-4 space-y-4">

    <!-- Search Box -->
    <div
      class="relative w-full h-11 rounded-2xl bg-white shadow-sm flex items-center px-4 border border-slate-100 focus-within:border-amber-400 focus-within:ring-1 focus-within:ring-amber-400 transition-all">
      <img src="icons/search_slate.svg" class="w-5 h-5 mr-2" />
      <input type="text" [(ngModel)]="searchText" (input)="onSearch()"
        class="w-full h-full bg-transparent outline-none text-slate-800 placeholder-slate-400 text-xs font-medium"
        placeholder="{{ currentLang === 'TH' ? 'ค้นหาหมายเลขทะเบียนรถ...' : 'Search plate number...' }}">

      <button *ngIf="searchText" (click)="onClearSearch(); onSearch()"
        class="text-slate-400 hover:text-rose-500 transition outline-none">
        <img src="icons/cancel_slate.svg" class="w-5 h-5" />
      </button>
    </div>

    <!-- KPI Statistics Grid (Additional Premium Feature) -->
    <div class="grid grid-cols-2 gap-3" *ngIf="paymentMember.length > 0">
      <!-- Total Pending Items Card -->
      <div class="bg-white rounded-3xl p-3.5 border border-slate-100 shadow-sm text-left flex items-center gap-3">
        <div class="w-10 h-10 p-2 rounded-2xl bg-rose-50 text-rose-600 flex items-center justify-center flex-shrink-0">
          <img src="icons/pending_actions_red.svg" class="w-full h-full" />
        </div>
        <div class="min-w-0">
          <span class="text-[8px] font-bold text-slate-400 uppercase tracking-wider block">{{ currentLang === "TH" ?
            "รายการที่ค้าง" : "Pending" }}</span>
          <span class="text-sm font-black text-slate-800">{{ totalPendingCount }} {{ currentLang === "TH" ? "รายการ" :
            "items" }}</span>
        </div>
      </div>

      <!-- Pending Payments Card -->
      <div class="bg-white rounded-3xl p-3.5 border border-slate-100 shadow-sm text-left flex items-center gap-3">
        <div
          class="w-10 h-10 p-2 rounded-2xl bg-amber-50 text-amber-500 flex items-center justify-center flex-shrink-0">
          <img src="icons/payments_orange.svg" class="w-full h-full" />
        </div>
        <div class="min-w-0">
          <span class="text-[8px] font-bold text-slate-400 uppercase tracking-wider block">{{ currentLang === "TH" ?
            "ยอดชำระรวม" : "Total Pending" }}</span>
          <span class="text-sm font-black text-slate-800 truncate block">{{ totalPendingAmount | number : "1.2-2" }}
            ฿</span>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="(filteredPaymentMember ? filteredPaymentMember : paymentMember).length === 0"
      class="flex flex-col items-center justify-center py-20 text-slate-400">
      <i class="fa fa-ticket text-5xl opacity-40 mb-3"></i>
      <p class="text-xs font-bold">{{ currentLang === "TH" ? "ไม่พบรายการค้างชำระ" : "No pending payment found" }}</p>
      <p class="text-[10px] text-slate-400 mt-1 max-w-[200px] text-center leading-normal">
        {{ currentLang === "TH"
        ? "ไม่มีประวัติการต่ออายุหรือลงทะเบียนค้างจ่ายในระบบ"
        : "There are currently no active pending registration or renewal fees." }}
      </p>
    </div>

    <!-- Pending Payments Card List  /_ (click)="onClickPay(payment)" _/ -->
    <div class="space-y-4">
      <div *ngFor="let payment of (filteredPaymentMember ? filteredPaymentMember : paymentMember); let i = index"
        (click)="navigateToQr(payment)"
        class="relative bg-rose-100/25 backdrop-blur-md text-slate-800 rounded-[2rem] p-4.5 shadow-md overflow-hidden flex items-center justify-between group hover:shadow-lg hover:scale-[1.01] transition-all duration-300 border border-slate-100/50">

        <!-- Perfect clipped absolute left gold border (resolves rounded corners border overflow) -->
        <div class="absolute left-0 top-0 bottom-0 w-1.5 bg-rose-800 z-10"></div>

        <!-- Elegant circular overlay decoration on the right (matching the screenshot with a warm glow tint) -->
        <div
          class="absolute right-0 top-0 bottom-0 w-24 bg-amber-600/[0.04] rounded-l-full pointer-events-none backdrop-blur-[1px] z-1">
        </div>

        <!-- Left: Circular Logo (Matching the avatar) -->
        <div class="flex items-center gap-4 z-10 text-left min-w-0">
          <div
            class="w-14 h-14 bg-slate-50 rounded-full p-2 flex items-center justify-center shadow-sm flex-shrink-0 border border-slate-100">
            <img [src]="payment.logo" alt="logo" class="w-full h-full object-contain mix-blend-multiply" />
          </div>

          <!-- Middle: Title, Subtitle, and Dates -->
          <div class="min-w-0 flex flex-col justify-center">
            <h3 class="text-sm font-extrabold tracking-wide leading-tight line-clamp-1 mb-0.5 text-slate-800">
              {{ payment.plate_number }}
            </h3>
            <p class="text-[10px] text-slate-500 font-bold line-clamp-1">
              {{ payment.fee_name }}
            </p>

            <!-- Dates in horizontal grid (Followers/Likes style) -->
            <div class="flex items-center gap-3 text-[9px] text-slate-400 font-bold tracking-wide mt-2">
              <div>
                <span class="block text-slate-400 text-[9px] uppercase tracking-wider mb-0.5 leading-none">
                  <img src="icons/calendar_today_slate_dark.svg" class="w-5 h-5" />
                  {{ currentLang === "TH" ? "เริ่มใช้งาน" : "Start" }}
                </span>
                <span class="font-mono text-slate-600 font-bold text-[10px]">{{ payment.member_start }}</span>
              </div>
              <div class="w-[1px] h-3.5 bg-slate-200"></div>
              <div>
                <span class="block text-rose-500/90 text-[9px] uppercase tracking-wider mb-0.5 leading-none">
                  <img src="icons/calendar_today_red.svg" class="w-5 h-5" />
                  {{ currentLang === "TH" ? "วันหมดอายุ" : "Expiry" }}
                </span>
                <span class="font-mono text-rose-600 font-bold text-[10px]">{{ payment.expire_date }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Side: Circular highlighted shape containing Price & Pay action -->
        <div class="z-10 flex flex-col items-center justify-center pl-4 shrink-0 w-16 text-center">
          <div class="flex flex-col items-center gap-1.5 text-rose-800">
            <span class="text-sm font-black tracking-wide block leading-none text-rose-800">
              {{ payment.total | number : "1.0-0" }}
            </span>
            <span class="text-[7px] font-extrabold block tracking-widest leading-none mb-1 text-rose-800">THB</span>

            <!-- Pay Button / Paid indicator (Amber colored button to stand out against white) -->
            <button *ngIf="payment.total > 0"
              class="bg-rose-800 text-white hover:bg-rose-900 rounded-full w-9 h-9 p-2 flex items-center justify-center hover:shadow-md shadow-sm active:scale-90 transition-transform outline-none border-none">
              <img src="icons/payments_white.svg" class="w-full h-full" />
            </button>

            <div *ngIf="payment.total <= 0"
              class="w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center shadow-inner">
              <img src="icons/check_emerald.svg" class="w-full h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Premium Fullscreen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- ✅ MODAL: Choose Payment Method -->
<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-3 animate-fade-in"
  *ngIf="isOpenModalChose">
  <div class="bg-white w-full sm:max-w-sm rounded-[2.5rem] p-6 relative animate-scale-up border border-slate-100/50">

    <!-- Close Button -->
    <button (click)="closeModal()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-slate-50 hover:bg-slate-100 text-slate-400 hover:text-rose-500 transition-colors flex items-center justify-center outline-none border-none">✕</button>

    <div class="flex flex-col items-center text-center">
      <img src="icons/PSS/PSS Sticker-01.png" class="w-16 h-16 mb-3 drop-shadow-md object-contain" />
      <h3 class="text-sm font-black text-slate-800">
        {{ currentLang === "TH" ? "กรุณาเลือกวิธีการชำระเงิน" : "Please choose payment method" }}
      </h3>
      <p class="text-[10px] text-slate-400 font-bold mt-0.5 mb-6">
        {{ currentLang === "TH" ? "เลือกวิธีการชำระเงินเพื่อดำเนินการต่อ" : "Select a method below to complete payment"
        }}
      </p>

      <!-- Pay options button stack -->
      <div class="w-full space-y-3">
        <!-- QR Code -->
        <button (click)="navigateToQr()"
          class="w-full py-3.5 bg-amber-400 text-slate-800 rounded-2xl font-black shadow-md hover:bg-amber-500 active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 border-none outline-none text-xs">
          <img src="icons/qr_code_2_black.svg" class="w-5 h-5" />
          {{ currentLang === "TH" ? "ชำระด้วย QR Code (ThaiQR)" : "Pay with ThaiQR" }}
        </button>

        <!-- Top-up account balance -->
        <button (click)="navigateToTopup()"
          class="w-full py-3.5 bg-slate-100 hover:bg-slate-200/80 text-slate-700 rounded-2xl font-black active:scale-[0.98] transition-all flex items-center justify-center gap-1.5 outline-none border-none text-xs">
          <img src="icons/account_slate_black.svg" class="w-5 h-5" />
          {{ currentLang === "TH" ? "ชำระด้วยบัญชีเติมเงิน" : "Pay with Top Up Account" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ✅ MODAL: Topup Confirmation Details -->
<div *ngIf="isOpenModalTopup"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-fade-in">
  <div
    class="bg-white w-full max-w-sm rounded-[2.5rem] overflow-hidden shadow-2xl animate-scale-up border border-slate-100/50 flex flex-col">
    <!-- Header -->
    <div class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] p-6 text-center text-white relative">
      <button (click)="closeModal()"
        class="absolute top-4 right-4 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white/80 flex items-center justify-center border-none outline-none">
        <img src="icons/close_slate.svg" class="w-5 h-5" />
      </button>
      <h2 class="text-base font-black tracking-wide text-white mb-2">
        {{ currentLang === "TH" ? "ยืนยันชำระผ่านบัญชีเติมเงิน" : "Confirm Payment" }}
      </h2>
      <!-- Wallet balance badge -->
      <div
        class="inline-flex items-center gap-2 bg-white/10 border border-white/10 px-3.5 py-1 rounded-full text-white text-xs">
        <span class="opacity-80">Wallet Balance:</span>
        <span class="font-black text-amber-400">{{ topupAmount.amount | number : "1.2-2" }} ฿</span>
      </div>
    </div>

    <!-- Content details -->
    <div class="p-6 space-y-3.5 text-xs text-left">
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ผู้ให้บริการ" : "Provider" }}</span>
        <span class="font-black text-slate-800">{{ selectedTransaction?.provider_name }}</span>
      </div>
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ทะเบียนรถ" : "License Plate" }}</span>
        <span class="font-black text-slate-800">{{ selectedTransaction?.plate_number }}</span>
      </div>
      <div class="flex justify-between items-center border-b border-slate-100 pb-2.5">
        <span class="text-slate-400 font-bold">{{ currentLang === "TH" ? "ประเภทค่าบริการ" : "Service Type" }}</span>
        <span class="font-black text-slate-800">{{ selectedTransaction?.fee_name }}</span>
      </div>

      <!-- Total Fee block -->
      <div class="flex justify-between items-center bg-slate-50 p-4.5 rounded-2xl mt-2.5">
        <span class="font-black text-slate-600">{{ currentLang === "TH" ? "ยอดหักชำระรวม" : "Total Deducted" }}</span>
        <span class="font-extrabold text-lg text-rose-500">
          {{ selectedTransaction?.total | number : "1.2-2" }} ฿
        </span>
      </div>
    </div>

    <!-- Action buttons footer -->
    <div class="grid grid-cols-2 gap-0 border-t border-slate-100 text-xs">
      <button (click)="closeModal()"
        class="py-4 bg-slate-50 hover:bg-slate-100 text-slate-500 font-black transition border-none outline-none">
        {{ currentLang === "TH" ? "ยกเลิก" : "Cancel" }}
      </button>
      <button (click)="paymentTopup()"
        class="py-4 bg-amber-400 hover:bg-amber-500 text-slate-800 font-black transition border-none outline-none">
        {{ currentLang === "TH" ? "ยืนยันชำระเงิน" : "Confirm" }}
      </button>
    </div>
  </div>
</div>